// **************** common import *******************
import React from "react";
import NotesErrorList from "../notes_error_list";


// interface 
import { ChildProps } from "../../../utils/types/interFace";

const Index = ({filteredAccess}:ChildProps) => {
  const PageDetail = {
    error:'Missmatch source data',
    pageTitle:'Source Mismatch',
    pageDescription:'Encountered error while searching for the PointClickCare, several patients were found',
    pageNote:"System Errors ( WIll not require any user intervention. Scribe Smart Maintenance team( India Team) will take care of these errors. However, they wanted to display the issues for everyone's reference)"
  }
  
  return <NotesErrorList filteredAccess={filteredAccess} pageDetails={PageDetail} />
};

export default Index;